import type { ShippingAddress } from '@library/api-user'

const formatDeliveryDate = (date: Date | string): string =>
  new Intl.DateTimeFormat('en-GB', {
    dateStyle: 'full',
    timeZone: 'Europe/London',
  }).format(new Date(date))

const formatShippingAddress = (address?: ShippingAddress): string => {
  if (!address) {
    return ''
  }

  const { line1, line2, line3, postcode } = address
  const orderedAddressItems = [line1, line2, line3, postcode].filter((line: string) => !!line)
  const result = orderedAddressItems.join(', ')

  return result
}

export { formatDeliveryDate, formatShippingAddress }
